import { useState, useEffect } from "react";
const getOrientation = () => { var _a, _b; return (_b = (_a = window.screen) === null || _a === void 0 ? void 0 : _a.orientation) === null || _b === void 0 ? void 0 : _b.type; };
export const useScreenOrientation = () => {
    const [orientation, setOrientation] = useState(getOrientation());
    const updateOrientation = () => {
        setOrientation(getOrientation());
    };
    useEffect(() => {
        window.addEventListener("orientationchange", updateOrientation);
        return () => {
            window.removeEventListener("orientationchange", updateOrientation);
        };
    }, []);
    return orientation;
};
